export default __webpack_public_path__ + "static/media/p-sm-2.485e245d.png";